export const formatDateTime = (in_date) => {
    return new Date(Date.parse(in_date)).toLocaleString()
}
